module.exports = __webpack_public_path__ + "img/newicon4.8de443ef.png";